import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleArrowRight } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import PropertySelectionList from "../../property/PropertySelectionList/PropertySelectionList";
import AmpToolTip from "../../common/AmpToolTip/AmpToolTip";
import { alternateAddPropertyKey, setCurrentAddress, setCurrentOwnerType, setCurrentProperty, setRedirects } from "../../../redux/actions/propertySelectionList/propertySelectionList";
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from "../../../redux/reducers/root";
import { changeIsCloseable, changeModalContent, changeModalState } from "../../../redux/actions/modal/modal";
import AmpInlineLoadingSpinner from "../../common/AmpInlineLoadingSpinner/AmpInlineLoadingSpinner";

import "./CurrentPropertyDisplayer.css";
import AddProperty from "../../AddProperty/AddProperty";
import { isAmppa } from "../../../utils/isAmppa";
import { useLocation } from "react-router-dom";
import { getCurrentPropertyDetails } from "../../../redux/actions/currentPropertyDetails/currentPropertyDetails";

interface CurrentPropertyDisplayerProps {
    testing?: boolean;
}

export default function CurrentPropertyDisplayer(props: CurrentPropertyDisplayerProps): JSX.Element {
    const { t } = useTranslation("header");

    const [shouldShow, setShouldShow] = useState(true);

    const currentPropertyDetails = useSelector((state: RootState) => state.curPropertyDetailsReducer.currentPropertyDetails);

    const modalState = useSelector((state: RootState) => state.modalReducer);

    const modalContentAriaLabel: string = modalState['contentAriaLabel'];

    const modalIsCloseable: boolean = modalState['isCloseable'];

    const propertyDetails: Record<string, unknown> = currentPropertyDetails["propertyDetails"];

    const currentPhysicalAddress: string = propertyDetails ? 
        (propertyDetails["propertyData"]["municipalAddress"] ? 
            propertyDetails["propertyData"]["municipalAddress"] : 
            propertyDetails["propertyData"]["legalDescription"] ) :
        false;

    const pendingGettingPropertyDetails: boolean = currentPropertyDetails["loading"];

    const dispatch = useDispatch();
    const location = useLocation();

    const openModal = (modalCloseable: boolean) => {
        const ariaLabelText = t("property-list-modal.property-selection") as string;
        if (modalContentAriaLabel !== ariaLabelText) {
            dispatch(changeModalContent(<PropertySelectionList showFullVersion={false} onPropertySelected={closeModal} />,
                t("property-list-modal.property-selection") as string,
                ariaLabelText,
                t("property-list-modal.exit-property-list-aoda") as string,
                undefined,
                "header",
                "property-list-modal.property-selection",
                "property-list-modal.property-selection",
                "property-list-modal.exit-property-list-aoda"));
        }
        if (modalIsCloseable !== modalCloseable) {
            dispatch(changeIsCloseable(modalCloseable));
        }
        dispatch(changeModalState("modal-fade-in"));
    }

    const closeModal = () => {
        dispatch(changeModalState("modal-fade-out"));
    }

    const addProperty = () => {
        const ariaLabelText = t("add-property-modal.title") as string;
        dispatch(alternateAddPropertyKey());
        if (modalContentAriaLabel !== ariaLabelText) {
            dispatch(changeModalContent(<AddProperty />, ariaLabelText, ariaLabelText));
        }
        if (!modalIsCloseable) {
            dispatch(changeIsCloseable(true));
        }
		dispatch(changeModalState("modal-fade-in"));
    }
    useEffect(() => {
        const currentProperty = window.localStorage.getItem("currentProperty");
        const currentOwnerType = window.localStorage.getItem("o_type");
        const accptedToc = localStorage.getItem("acceptedToc");


        if(currentOwnerType){
            dispatch(setCurrentOwnerType(currentOwnerType))
        }
        if (currentProperty) {
            if(!propertyDetails && !pendingGettingPropertyDetails){
                dispatch(getCurrentPropertyDetails(currentProperty))
            }
            dispatch(setCurrentProperty(currentProperty));
        } else if ((accptedToc && location.pathname !== "/amp/contact-us") || props.testing) {
            dispatch(setRedirects(false));
            openModal(false);
        } else if (!accptedToc){
            setShouldShow(false);
        }
    // eslint-disable-next-line
    }, [location.pathname]);

    useEffect(() => {
        if (propertyDetails) {
            const physicalAddress = propertyDetails["addressPhysical"] as Record<string, string | null>;
            if (physicalAddress && physicalAddress["municipalAddress"]) {
                window.localStorage.setItem("currentAddress", physicalAddress["municipalAddress"]);
                dispatch(setCurrentAddress(physicalAddress["municipalAddress"]));
                return;
            }
        }
    }, [propertyDetails, dispatch]);

    return (
        <>
            {shouldShow && <div className="current-property-displayer">
                <button className="address-picker-button" onClick={() => openModal(true)}  data-testid="property-selection-button-test" aria-label={currentPhysicalAddress}>
                    <div className="address-picker-icon" aria-label={t("header.view-property-aoda") as string}><FontAwesomeIcon className="address-picker-font-awesome-icon" icon={faCircleArrowRight} /></div>
                    <div className="current-property-address">{currentPhysicalAddress && !pendingGettingPropertyDetails ? currentPhysicalAddress : (pendingGettingPropertyDetails ? <AmpInlineLoadingSpinner /> : currentPhysicalAddress)}</div>
                </button>
                {!isAmppa ?
                    <div className="displayer-add-property">
                        <button className="displayer-add-property-button" onClick={() => addProperty()}>{t("header.add-property") as string}</button>
                        <AmpToolTip id={"addPropertyToolTip"} content={t("header.add-property-tooltip") as string} direction="right"/>
                    </div>
                    : <></>
                }
            </div>}       
        </>
    );
}